import styled from "@emotion/styled";
import {Box, Button} from "@mui/material";
import {media} from "assets/css/media";
import {PlayerPoolSlotImage} from "views/components/style/pool";
import {css} from "@mui/material/styles";

const captainBgStyleDesktop = css`
	background: linear-gradient(205deg, #0041f9 21.4%, #ff0019 87.32%);
`;
const captainBgStyleMobile = css`
	background: linear-gradient(264deg, #0041f9 -11.71%, #ff0019 95.17%);
`;
const captainFontStyle = css`
	color: #fff;
`;
export const FilledSlot = styled(Box)<{isCaptain: boolean}>`
	border-radius: 10px;
	background: #fff;
	box-shadow: 0 0 2px 0 rgba(28, 28, 30, 0.2);
	display: flex;
	padding: 6px;
	flex-direction: column;
	align-items: flex-start;
	gap: 16px;
	flex: 1 1 100%;
	position: relative;
	${({isCaptain}) => isCaptain && captainBgStyleDesktop}
`;
export const EmptySlot = styled(Box)`
	border-radius: 10px;
	background: #fff;
	box-shadow: 0 0 2px 0 rgba(28, 28, 30, 0.2);
	display: flex;
	padding: 6px;
	flex-direction: column;
	align-items: flex-start;
	gap: 16px;
	flex: 1 1 100%;
`;

export const EmptyMobileSlot = styled(Box)<{isCaptain?: boolean}>`
	position: relative;
	width: 100%;
	max-height: 90px;
	min-height: 86px;
	box-shadow: 0 0 2px rgba(28, 28, 30, 0.2);
	border-radius: 8px;
	display: flex;
	overflow: hidden;
	background: #fff;
	padding: 4px 50px 4px 4px;
	gap: 10px;

	p.title {
		display: flex;
		align-items: center;
		color: var(--thirdColor);
		font-feature-settings: "clig" off, "liga" off;
		font-family: var(--fontFamilyBase);
		font-size: 14px;
		font-style: normal;
		font-weight: 600;
		line-height: 140%; /* 19.6px */
		text-transform: uppercase;
	}

	// @media (max-width: ${media.mobile}) {
	// 	margin-bottom: 6px;
	// 	max-height: 66px;
	// 	min-height: 66px;
	// }
`;
export const FilledMobileSlot = styled(EmptyMobileSlot)`
	padding: 4px 90px 4px 4px;
	position: relative;
	color: var(--thirdColor);
	max-height: 90px;

	${({isCaptain}) => isCaptain && captainFontStyle}
	${({isCaptain}) => isCaptain && captainBgStyleMobile}
`;
export const MobilePlayerSlotImage = styled(PlayerPoolSlotImage)`
	width: 88px;
	flex: unset;
	border: 1px solid #fff;

	background: rgba(1, 21, 54, 0.3);
`;
export const PlayerImageSection = styled(Box)<{withPlayer: boolean}>`
	border-radius: 8px;
	background: rgba(1, 21, 54, 0.3);
	border: 1px solid #fff;
	display: flex;
	width: 100%;
	//min-height: 140px;
	height: 160px;
	padding: 0;
	justify-content: center;
	align-items: ${({withPlayer}) => (withPlayer ? "flex-start" : "flex-end")};
	overflow: hidden;
	cursor: pointer;

	&:hover + .player-info .hover-underline {
		text-decoration: underline;
	}

	&.europe {
		background: ${({withPlayer}) =>
			withPlayer ? "linear-gradient(180deg, #0076EB 0%, #003C82 100%)" : "transparent"};
	}

	&.usa {
		background: ${({withPlayer}) =>
			withPlayer ? "linear-gradient(180deg, #FB4D56 0%, #FF0019 100%)" : "transparent"};
	}

	@media (max-width: 1024px) {
		height: 240px;
	}

	@media (max-width: 480px) {
		height: 160px;
	}

	img {
		display: block;
		width: 100%;

		@media (max-width: ${media.mobile}) {
			width: 100%;
		}
	}
`;
export const ActionRow = styled(Box)`
	width: 100%;
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 16px;
	padding-bottom: 10px;

	&.empty_mobile_slot {
		position: absolute;
		top: 50%;
		right: 10px;
		transform: translateY(-50%);
		width: unset;
		padding: 0;

		svg {
			transform: scale(1.8);
		}
	}
`;
export const PlayerInfo = styled(Box)<{isCaptain?: boolean}>`
	display: flex;
	flex-direction: column;
	gap: 6px;
	flex: 1;
	width: 100%;
	color: var(--thirdColor);
	cursor: pointer;

	&:hover .hover-underline {
		text-decoration: underline;
	}

	${({isCaptain}) => isCaptain && captainFontStyle}
`;
export const InfoCell = styled(Box)`
	display: flex;
	flex-direction: column;
	height: 100%;
`;
export const DataCell = styled(Box)`
	flex-shrink: 0;
	//background: var(--thirdColor);
	color: #fff;
	display: flex;
	justify-content: center;
	align-items: stretch;
	border-radius: 0 0 8px 8px;
	text-align: center;
	font-size: 16px;
	font-family: var(--fontFamilyBase);
	font-style: normal;
	font-weight: 500;
	line-height: 104%;
	box-sizing: border-box;
	overflow: hidden;
`;
export const PointsCell = styled(Box)<{isCaptain?: boolean}>`
	flex: 1 1 100%;
	background: #0041f9;
	min-height: 40px;
	display: flex;
	align-items: center;
	justify-content: center;
	flex-direction: column;
	padding: 4px 8px;

	@media (max-width: ${media.mobile}) {
		padding: 4px;
		gap: 5px;
		text-align: center;
		color: #fff;
	}

	p {
		text-align: center;

		&.title {
			text-align: center;
			font-feature-settings: "clig" off, "liga" off;
			font-family: var(--fontFamilyBase);
			font-size: 12px;
			font-style: normal;
			font-weight: 500;
			line-height: 130%; /* 15.6px */
		}
	}
`;
export const PickedCell = styled(Box)`
	flex: 1 1 100%;
	background: var(--thirdColor);
	min-height: 40px;
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 4px 8px;
`;
export const ResultCell = styled(Box)`
	flex: 1 1 100%;
	background: var(--thirdColor);
	min-height: 40px;
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 4px 8px;

	@media (max-width: ${media.mobile}) {
		padding: 4px;
	}

	p {
		text-align: center;

		&.title {
			text-align: center;
			font-feature-settings: "clig" off, "liga" off;
			font-family: var(--fontFamilyBase);
			font-size: 16px;
			font-style: normal;
			font-weight: 500;
			line-height: 130%; /* 15.6px */
		}

		b {
			color: #fff;
			font-feature-settings: "clig" off, "liga" off;
			font-family: var(--fontFamilyFifth);
			font-size: 16px;
			font-style: normal;
			font-weight: 700;
			line-height: 140%; /* 22.4px */
			text-transform: uppercase;
			margin-right: 5px;
		}

		span {
			color: #fff;
			font-feature-settings: "clig" off, "liga" off;
			font-family: var(--fontFamilyThird);
			font-size: 11px;
			font-style: normal;
			font-weight: 600;
			line-height: 130%; /* 14.3px */
			text-transform: none;
		}
	}

	span {
		color: #fff;
		font-feature-settings: "clig" off, "liga" off;
		font-family: var(--fontFamilyFifth);
		font-size: 18px;
		font-style: normal;
		font-weight: 900;
		line-height: 140%; /* 22.4px */
		letter-spacing: 1px;
		text-transform: uppercase;
	}
`;

export const ArrowBox = styled(Box)`
	display: inline-flex;
	align-items: center;
	justify-content: center;

	&.win {
	}

	&.lose {
		transform: rotate(180deg);

		svg {
			path {
				fill: #ff0019;
			}
		}
	}

	&.tied {
		display: none;
	}
`;
export const Circle = styled(Box)`
	display: flex;
	justify-content: center;
	align-items: center;
	width: 18px;
	height: 18px;
	flex-direction: column;
	flex-shrink: 0;
	color: #fff;
	text-align: center;
	font-feature-settings: "clig" off, "liga" off;
	font-family: var(--fontFamilyThird);
	font-size: 11px;
	font-style: normal;
	font-weight: 800;
	border-radius: 50%;
	margin-right: 6px;
	line-height: 16px;
	border: 1px solid #fff;

	@media (max-width: ${media.mobile}) {
		margin: 0;
	}

	&.win {
		background: #338600;
	}

	&.lose {
		background: #ff031c;
	}

	&.tied {
		background: #e8e8e8;
		color: var(--thirdColor);
	}
`;
export const Name = styled.p`
	//color: var(--thirdColor);
	color: inherit;
	font-size: 14px;
	font-family: var(--fontFamilyBase);
	font-style: normal;
	font-weight: 500;
	line-height: 140%;
	text-transform: uppercase;

	span {
		display: inline-block;
		//color: var(--thirdColor);
		color: inherit;
		font-size: 14px;
		font-family: var(--fontFamilyBase);
		font-style: normal;
		font-weight: 500;
		line-height: 140%;
		text-transform: uppercase;
	}
`;
export const NameCapitalise = styled.p`
	//color: var(--thirdColor);
	color: inherit;
	font-family: var(--fontFamilyBase);
	font-style: normal;

	text-transform: capitalize;
	font-size: 14px;
	font-weight: 400;
	line-height: 18px;
	letter-spacing: 0px;
	text-align: left;

	span {
		display: inline-block;
		color: var(--thirdColor);
		font-size: 14px;
		font-family: var(--fontFamilyBase);
		font-style: normal;
		font-weight: 500;
		line-height: 140%;
		text-transform: uppercase;
	}
`;
export const NextMatch = styled.p`
	//color: var(--thirdColor);
	color: inherit;
	font-size: 12px;
	font-family: var(--fontFamilyBase);
	font-style: normal;
	font-weight: 400;
	line-height: 130%;
	margin-top: 4px;

	span {
		font-size: 12px;
		font-family: var(--fontFamilyBase);
		font-weight: 400;
		line-height: 100%;
		display: inline-flex;
		color: inherit;

		@media (max-width: ${media.mobile}) {
			display: inline-flex;
			//margin-right: 5px;
		}

		&.bold {
			font-weight: 500;
			display: inline-flex;
		}
	}
`;

export const NextMatchNotPlaying = styled(NextMatch)`
	display: flex;
	align-items: flex-end;
	flex-grow: 1;
`;

export const Flag = styled(Box)<{isCaptain?: boolean}>`
	display: flex;
	width: 22px;
	height: 13px;
	overflow: hidden;
	border-radius: 3px;
	margin-right: 4px;

	img {
		width: 100%;
		display: block;
		border: 1px solid ${({isCaptain}) => (isCaptain ? "#FFF" : "transparent")};
	}
`;
export const AddButton = styled(Button)`
	width: 32px;
	height: 32px;
	background: var(--primaryColor);
	border-radius: 50%;
	min-width: unset;

	&:hover {
		background: var(--thirdColor);
	}
`;

export const LockedButton = styled(AddButton)`
	background: #e5e5ea;

	&.m_view {
		position: absolute;
		top: 50%;
		right: 20px;
		transform: translateY(-50%);
	}
`;

export const IconTradeBtn = styled(Button)`
	width: 32px;
	height: 32px;
	border-radius: 50%;
	display: flex;
	justify-content: center;
	align-items: center;
	position: absolute;
	right: 10px;
	top: 10px;
	min-width: unset;
	padding: 0;
	border: 1px solid var(--thirdColor);
	background: var(--thirdColor);

	&.m_view {
		top: 50%;
		transform: translateY(-50%);
	}

	&:disabled {
		border: 1px solid #e5e5ea;
		background: #e5e5ea;
		svg circle {
			fill: #e5e5ea;
		}
	}
`;

export const IconCapBtn = styled(Button)`
	width: 32px;
	height: 32px;
	border-radius: 50%;
	display: flex;
	justify-content: center;
	align-items: center;
	position: absolute;
	left: 10px;
	top: 10px;
	min-width: unset;
	padding: 0;
	border: none;

	&.selected {
		border: 1px solid var(--thirdColor);
		background: var(--thirdColor);
	}

	&.m_view {
		position: absolute;
		left: unset;
		right: 50px;
		top: 50%;
		transform: translateY(-50%);
		//border: 1px solid var(--thirdColor);

		svg {
			path {
				fill: var(--thirdColor);
			}

			circle {
				stroke: var(--thirdColor);
			}
		}

		&.selected {
			background: var(--thirdColor);
			border: none;

			svg {
				path {
					fill: #fff;
				}
			}
		}
	}
`;
export const IconCap = styled(Box)`
	width: 24px;
	height: 24px;
	border-radius: 50%;
	display: flex;
	justify-content: center;
	align-items: center;
	position: absolute;
	left: 10px;
	top: 10px;
	min-width: unset;
	padding: 0;
	border: none;

	&.m_view {
		position: absolute;
		left: 3px;
		top: 3px;

		svg {
			path {
				fill: var(--thirdColor);
			}

			circle {
				stroke: var(--thirdColor);
			}
		}

		&.selected {
			background: var(--thirdColor);
			border: none;

			svg {
				path {
					fill: #fff;
				}
			}
		}
	}

	&.d_view {
		width: 32px;
		height: 32px;

		&.selected {
			border: 1px solid var(--thirdColor);
			background: var(--thirdColor);
		}
	}
`;
const buttonMobileStyles = css`
	border: 1px solid var(--secondaryColor);
	background: var(--secondaryColor);
	position: absolute;
	top: 50%;
	right: 10px;
	transform: translateY(-50%);
`;

export const IconRemove = styled(Button)<{isMobile?: boolean}>`
	width: 32px;
	height: 32px;
	border-radius: 50%;
	border: 1px solid #fff;
	background: #fff;
	display: flex;
	justify-content: center;
	align-items: center;
	position: absolute;
	right: 10px;
	top: 10px;
	min-width: unset;

	${({isMobile}) => isMobile && buttonMobileStyles}
	&:hover {
		background: var(--thirdColor);
		border: 1px solid var(--thirdColor);
	}

	svg {
		transform: scale(1.8);
	}

	&.europe {
		svg {
			path {
				fill: var(--primaryColor);
			}
		}
	}

	&.usa {
		svg {
			path {
				fill: var(--secondaryColor);
			}
		}
	}
`;

export const PointsCellMobile = styled(Box)<{isCaptain?: boolean}>`
	position: absolute;
	top: 2px;
	bottom: 2px;
	right: 2px;
	//transform: translateY(-50%);
	display: flex;
	flex-direction: column;
	gap: 4px;
	max-width: 80px;
	overflow: hidden;
	border-radius: 0 8px 8px 0;
	background: #0041f9;
	color: #fff;
	padding: 4px 8px;
	align-items: center;
	justify-content: center;
`;
export const PointsValue = styled(Box)`
	font-family: var(--fontFamilyBase);
	font-size: 16px;
	font-style: normal;
	font-weight: 900;
	line-height: 130%; /* 18.2px */
	display: flex;
	justify-content: center;
`;
export const PointsTitle = styled(Box)`
	font-family: var(--fontFamilyBase);
	font-size: 12px;
	font-style: normal;
	font-weight: 400;
	line-height: 130%; /* 18.2px */
	display: flex;
	justify-content: center;
	text-align: center;
`;
